import { JobAuthProvider } from "../hooks/useAuth"; // Jobs-specific auth
import { Outlet } from "react-router-dom";

const JobsModule = () => {
  return (
    <JobAuthProvider>
      <Outlet />
    </JobAuthProvider>
  );
};

export default JobsModule;
